<template>
    <standard-layout :header="voucher.code" v-if="voucher" type="voucher">
        <template v-slot:main>
            <voucher-detail :voucher="voucher" :panel-layout="true"/>
            <div>
                <button class="btn btn-success" @click="sendVoucher">Per Email an Kunden senden</button>
            </div>
            <div class="row mt-3" v-if="voucher.orderedIn">
                <div class="col-12 text-secondary h5">Bestellt in</div>
                <div class="col-12" v-if="voucher.orderedIn">
                    <order-detail :order="voucher.orderedIn"/>
                </div>
            </div>
        </template>
    </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import OrderDetail from "@/components/order/OrderDetail";
import VoucherDetail from "@/components/voucher/VoucherDetail";

export default {
    components: {VoucherDetail, StandardLayout, OrderDetail},
    props: {
        id: String
    },
    data() {
        return {
            voucher: null
        }
    },
    watch: {
        id: {
            immediate: true,
            handler: 'loadVoucher'
        }
    },
    methods: {
        async loadVoucher() {
            const v = await this.$api.get(`/vouchers/${this.id}`)
                .then(res => res.data)
                .catch(err => this.handleError(err))
            this.voucher = v;
        },
        async sendVoucher(){
            try {
                await this.$api.put(`/vouchers/${this.id}/send`)
                this.showInfo("Der Gutschein wurde verschickt")
            } catch(err) {
                this.handleEror(err)
            }
        }
    }
}
</script>
